module.exports = __webpack_public_path__ + "img/86.something_else.66b8406e.svg";